var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/shift-creator-edit.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-33e7284a!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/shift-creator-edit.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ShiftCreatorEdit.vue
// module id = 720
// module chunks = 1